import * as React from "react"
import {useEffect} from "react"
import {Navigate} from "react-router-dom";

import {SESSIONS_ROUTES} from "@constants";
import {useUserApp} from "@hooks";


export default function LogoutPage() {
	const { handleLogout, isLogged } = useUserApp(true)

	useEffect(() => {
		handleLogout()
	}, [])

	if (!isLogged)
		return <Navigate to={SESSIONS_ROUTES.LOGIN_URL} replace />

	return <></>
}